module.exports = __webpack_public_path__ + "static/media/logo-dark.fe736a25.png";